import { moment } from 'Imports';

// Helper function to convert moment or Date to Date object
export const toDate = (date: Date | moment.Moment): Date => {
    if (moment.isMoment(date)) {
        return date.toDate();
    }
    return date as Date;
};

// Utility function to normalize a date to start of day (00:00:00.000Z)
export const normalizeToStartOfDay = (date: Date) => {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
};
